import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "hidden lg:block" }
const _hoisted_3 = {
  key: 0,
  class: "bg-white w-72 rounded shadow-lg absolute right-0 max-h-96 overflow-y-scroll flex flex-col gap-4 py-4"
}
const _hoisted_4 = { class: "flex flex-row items-center gap-2 px-4" }
const _hoisted_5 = { class: "flex flex-col items-start" }
const _hoisted_6 = { class: "text-sm text-start font-bold" }
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = { class: "w-full flex flex-col items-start gap-3 text-left px-8" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full bg-[#00000029]" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mdicon = _resolveComponent("mdicon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("a", {
        class: "text-sm flex flex-row cursor-pointer text-white hover:text-light-green items-center gap-2",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMenu()))
      }, [
        _createVNode(_component_mdicon, {
          name: "account-circle",
          size: "30"
        }),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.user?.firstName) + " " + _toDisplayString(_ctx.user?.lastName), 1)
      ])
    ]),
    (_ctx.menuIsVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_mdicon, {
              name: "account-circle",
              size: "40"
            }),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.user?.firstName) + " " + _toDisplayString(_ctx.user?.lastName), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.user?.email), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_router_link, {
              class: "w-full flex gap-3 items-center hover:text-light-green",
              to: { name: 'MyPerfil' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_mdicon, {
                  name: "account",
                  size: "20",
                  class: ""
                }),
                _createTextVNode(" Perfil ")
              ]),
              _: 1
            })
          ]),
          _hoisted_9,
          _createElementVNode("a", {
            class: "px-8 text-left text-regular font-normal hover:text-light-green flex items-center gap-3",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
          }, [
            _createVNode(_component_mdicon, {
              name: "power-standby",
              size: "20",
              class: ""
            }),
            _createTextVNode(" Cerrar sesión ")
          ])
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_click_outside, _ctx.clickOutside]
  ])
}